export default __webpack_public_path__ + "static/media/dashboard.147882a7.svg";